import React from 'react'
import { Flex, Image, Typography, Popconfirm } from 'antd'
import "./Details.scss"

const { Text } = Typography

const ShareDetail = ({ popTitle, onConfirm, icon, shareDesc }) => {
    return (
        <Popconfirm
            title={popTitle}
            okText="Yes"
            cancelText="No"
            onConfirm={onConfirm}
            overlayStyle={{ width: 300 }}
        >
            <Flex align="center" vertical gap="small">
                <div className="social-icon-container">
                    <Image preview={false} src={icon} alt="Mail" />
                </div>
                <Text style={{ color: "#40566D", fontWeight: 500 }}>{shareDesc}</Text>
            </Flex>
        </Popconfirm>
    )
}

export default ShareDetail